<template>
  <div class="profileIndex">
     <keep-alive :include='includes' :max="10">
      <router-view></router-view>
      </keep-alive>
  </div>
</template>

<style lang="less" scoped>
.profileIndex{
    min-height: 100%;
    background-color: #fff!important;
}
</style>


<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: "profile",
  components: {},
  data() {
    return {};
  },
  computed: {// 在computed中动态监控
     ...mapState({
       includes: state => state.includes,
     }),
   },
  mounted() {
      
  },
  created() {},
  methods: {
      
  }
};
</script>
